import { render, staticRenderFns } from "./iconReference.vue?vue&type=template&id=00b89bd8"
import script from "./iconReference.vue?vue&type=script&lang=js"
export * from "./iconReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports